<template>
  <div class="tariff-info-wrapper">
    <TariffCard :tariff="bookedTariff" class="hide-mobile"></TariffCard>
    <TariffCardCompact :tariff="bookedTariff" class="hide-desktop"></TariffCardCompact>
  </div>
</template>

<script>
import TariffCard from './TariffCard.vue'
import TariffCardCompact from './TariffCardCompact.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import joinTariffExtra from '@/helper/joinTariffExtras'
import extraData from '@/mixins/extraData'

export default {
  name: 'TariffInfo',
  components: {
    TariffCard,
    TariffCardCompact
  },
  data() {
    return {
      tariffs: {
        bookedTariff: null,
        pendingTariff: null
      }
    }
  },
  mixins: [extraData()],
  methods: {
    compileTariff(tariff) {
      tariff = joinTariffExtra(tariff, this.extraData.tariffs)
      return tariff
    }
  },
  computed: {
    bookedTariff() {
      if (this.tariffs.bookedTariff) {
        return this.compileTariff(this.tariffs.bookedTariff)
      }
      return null
    }
  },
  apollo: {
    tariffs: function() {
      return wrapQuery(
        gql`
          query bookedTariff {
            tariffs {
              bookedTariff {
                bandwidth {
                  down
                  up
                }
                tariffId
                name
                basicFee
                statusKey
                smsFlat
                cancelable
                tariffChangePossible
                isPendingTariff
                isSuspendedActive
                phoneFlat
                tariffState
                renewContractDate
                possibleChangingDate
                terminationDate
                changeTariffDate
                tariffText
                runtime {
                  amount
                  unit
                }
                volumes {
                  amount
                  formattedUnit
                  type
                  unit
                }
                extraDataVolumeText
                extraDataVolumes {
                    primary
                    secondary
                }
                extraDataDetails {
                    type
                    primary
                    secondary
                }
              }
            }
          }
        `,
        this,
        'tariffs'
      )
    }
  }
}
</script>
